@if (!isHidden) {
  <div>
    <aggregate-card [aggregate]="aggregate" [aggregateCriteria]="aggregateCriteria">
    </aggregate-card>
  </div>
}